// Тексты ошибок полей — те же предложения, что у бэкенда (epl_backend internal/errcode/message.go).
// Ошибку с сервера показываем его же текстом; эти тексты — для проверок на клиенте до запроса,
// чтобы поле говорило одно и то же, кто бы ни заметил ошибку.
export const FIELD_MESSAGES = {
  required: 'Обязательное поле',
  invalid: 'Некорректное значение',
  invalidEmail: 'Некорректный email',
  invalidSnils: 'Некорректный СНИЛС',
  invalidLicenseSer: 'Серия удостоверения: 4 символа',
  invalidLicenseNumber: 'Номер удостоверения: 6 цифр',
  autoparkRequired: 'Укажите автопарк',
} as const;
